var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var getChangedValues = function (oldValues, newValues) {
    console.log('oldValues: ', oldValues);
    console.log('newValues: ', newValues);
    var values = __assign({}, newValues);
    Object.entries(oldValues).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (oldValues[key] === values[key]) {
            delete values[key];
        }
    });
    return values;
};



//////////////////
// WEBPACK FOOTER
// ./src/helpers/getChangedValues.ts
// module id = 588
// module chunks = 0